<script>
import { mapActions, mapGetters } from 'vuex'

import Layout from '@layouts/main.vue'
import Search from '@components/search.vue'
import PageHeader from '@components/page-header.vue'

export default {
  page: {
    title: 'Table Input',
    meta: [{ name: 'description', content: '' }],
  },
  components: {
    PageHeader,
    Layout,
    Search,
  },
  data: () => ({
    searchFocus: false,
    tableNumber: null,
  }),
  computed: {
    ...mapGetters({
      items: 'payment/getItems',
      paymentLoading: 'payment/getLoading',
      geolocating: 'location/getGeolocating',
      searchLoading: 'location/getSearchLoading',
      content: 'contentful/getContent',
      contentLoading: 'contentful/getLoading',
      nearestLocations: 'location/getNearestLocations',
      location: 'location/getLocation',
    }),
    filteredLocations() {
      if (!this.search || (this.search && this.search.length < 3)) return []
      return this.nearestLocations.filter((location) =>
        `${location.name}|${location.address}`
          .toLowerCase()
          .includes(this.search.toLowerCase())
      )
    },
    loading() {
      return this.contentLoading || this.paymentLoading
    },
    dropdownVisible() {
      return this.filteredLocations && this.filteredLocations.length
    },
  },
  beforeMount() {
    this.setNearestToAll()
  },
  methods: {
    ...mapActions({
      getBill: 'payment/getBill',
      setLoading: 'payment/setLoading',
      setTableNumber: 'payment/setTableNumber',
      searchLocation: 'location/searchLocation',
      selectLocation: 'location/selectLocation',
      setNearestToAll: 'location/setNearestToAll',
    }),
    handleSelect(location) {
      try {
        this.selectLocation({ location })
        this.searchFocus = false
      } catch (e) {
        this.$store.dispatch(
          'ui/showError',
          "Couldn't select this location, please speak to your server."
        )
      }
    },
    handleSearchFocus() {
      this.selectLocation({ location: null })
      this.searchFocus = true
    },
    async handleSubmit() {
      try {
        await this.getBill({ tableNumber: this.tableNumber })

        if (this.items) {
          this.$router
            .push(`${this.location.slug}/table/${this.tableNumber}`)
            .catch(() => {})
        }
      } catch (e) {
        await this.$store.dispatch(
          'ui/showError',
          "Couldn't get the bill for your table, please speak to your server."
        )
      }
    },
  },
}
</script>

<template>
  <Layout screen="input">
    <PageHeader :page="0" title="Select your location" />
    <div class="content">
      <div :class="$style.intro">
        <Search
          :placeholder="location ? location.name : 'Search locations'"
          :items="nearestLocations"
          @select="handleSelect"
          @focus="handleSearchFocus"
        />

        <form @submit.prevent="handleSubmit">
          <div v-if="location && !searchFocus" :class="$style.tableNumber">
            <h2 :class="$style.sectionHeader">Enter table number</h2>
            <BaseInputText
              v-model="tableNumber"
              :class="$style.tableInput"
              type="number"
              min="0"
            />
          </div>
        </form>
      </div>
      <div class="footer">
        <form @submit.prevent="handleSubmit">
          <BaseButton
            :disabled="!location || !tableNumber || loading"
            :loading="loading"
          >
            Next
          </BaseButton>
        </form>
        <div :class="$style.spacer">
          <BaseLink v-if="content" :href="content.termsConditionsUrl">
            Terms & Conditions
          </BaseLink>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.intro {
  width: 100%;
  padding: 0.5rem 0 2rem;
}

.tableNumber {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.tableInput {
  font-size: 50px;
  display: block;
  max-width: 100%;
  margin: auto;
  width: 140px;
}

.buttons {
  padding: 0.5rem 0 1.5rem;
  width: 100%;
}

.spacer {
  margin: 20px 0;
}

.sectionHeader {
  max-width: 250px;
  padding-bottom: 1rem;
}
</style>
